var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"_jshWrap"},[_c('div',{staticClass:"_cont"},[_c('div',{ref:"myHtml",staticClass:"_html",domProps:{"innerHTML":_vm._s(_vm.allData.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }